import PubSub from 'pubsub-js'

declare global {
  interface Window {
    plausible: any
  }
}

export class Plausible {
  static init = () => {
    // Page view tracking
    PubSub.subscribe('pageview', (event, data) => window.plausible(event, { u: data.url }))

    // Generic event tracking
    const monitoredEvents = ['user/signup', 'user/login', 'channel/create', 'form/create', 'account/invite', 'account/upgrade', 'account/downgrade']
    monitoredEvents.map((e) =>
      PubSub.subscribe(e, (event, _data) =>
        window.plausible(event)
      )
    )
  }
}